var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.99988C9.791 1.99988 8 3.79088 8 5.99988V9.99988H16V5.99988C16 3.79088 14.209 1.99988 12 1.99988ZM18 10V6C18 2.687 15.313 0 12 0C8.687 0 6 2.687 6 6V10C4.343 10 3 11.343 3 13V21C3 22.657 4.343 24 6 24H18C19.657 24 21 22.657 21 21V13C21 11.343 19.657 10 18 10ZM6 12C5.448 12 5 12.448 5 13V21C5 21.552 5.448 22 6 22H18C18.552 22 19 21.552 19 21V13C19 12.448 18.552 12 18 12H6ZM12 15C12.552 15 13 15.448 13 16V18C13 18.552 12.552 19 12 19C11.448 19 11 18.552 11 18V16C11 15.448 11.448 15 12 15Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/Password.4e9e3af7401f9fd0a804406bef061c1b.svg";
export { ForwardRef as ReactComponent };